/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

//qids
export const businessTypeQid: string = 'CMP1_CD.010';
export const impTypeQid: string = 'MSCA_CD.003';
export const remitFreqQid = 'IMP1_CD.028';
export const stateQid = 'CUST.CERTSTATE';
export const subsidyNameQid = 'SUB8_CD.008';

//address type
export const primaryAddress = '01';

//business type keywords
export const insuranceBusinessTypeKw: string = 'INSURANCE';
export const miBusinessTypeKw: string = 'MI COMPANY';
export const hoaBusinessTypeKw: string = 'HOA';

//company codes
export const hudCompCode: string = '0MICXX002';
export const usdaCompCode: string = '0MICXX016';
//pmi company codes
export const mgicCompCode: string = 'MAGICMILW';
export const radianCompCode: string = '0MICXX005';
export const archmiCompCode: string = '0HICTX208';
export const essentCompCode: string = '0MICXX011';
export const enactCompCode: string = '0MICXX000';
export const nationalmiCompCode: string = '0MICXX013';
export const pmiCompanyCodes: Set<string> = new Set([
  mgicCompCode,
  radianCompCode,
  archmiCompCode,
  essentCompCode,
  enactCompCode,
  nationalmiCompCode,
]);

//login related
export const maxEmailLength: number = 71; // max length for email in database (brw1_cd.acEmail, cmp4_cd.acEmail, cmp1_cd.ACEMAILADDR)
export const passwordRequirementsMsg: string =
  'Password must include a capital letter, a lowercase letter, a number, a special character, and be between 8-20 characters long.';
export const borrowerNoAccessMsg: string =
  'Borrower does not have access to this information. Please login as a servicer.';
export const timeoutWarningSeconds: number = 120; // the seconds before the user will be timed out, when the timeout warning modal pops up
export const pathsNoLoginRequired: string[] = [
  '/',
  '/login',
  '/login-servicer',
  '/create-new-account',
  '/reset-password',
  '/error',
  '/authenticate',
];

//emails
export const noReplyEmail: string = 'noreply@swmc.com';

//various regex patterns
export const zipCodePattern: RegExp = /^[0-9]{5}$|^[0-9]{9}$/;
export const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const phoneNoPattern: RegExp = /^[0-9]{10}$/;
export const payeeTinPattern: RegExp = /^[0-9]{9}$/;

//access error messages
export const helocErrorMsg: string = 'Error: This page is not applicable for HELOC loans.';

//servicing stop codes
export const payoffFreezeStopCode: string = 'ST13';

//policy escrow status character for impounds
export const impPolicyStatusEscrowed: string = '1';
export const impPolicyStatusNonEscrowed: string = '2';

//misc payee
export const borrowerPayeeNo: string = '999999';
